import withStyles from 'isomorphic-style-loader/lib/withStyles';

import React from 'react';
import Panel from 'react-bootstrap/lib/Panel';

import References from '../../../components/Help/Demographics/References';

import s from './CollegeStudentsSection.scss';

class CollegeStudentsSection extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Panel>
          <Panel.Heading>College Students</Panel.Heading>
          <Panel.Body>
            <p>
              Shadower will be useful to college students who 1). are unsure
              about future career paths 2). feel like they need more real-world
              experience to be competitive or 3). are unable to secure an
              internship for whatever reason. Considering the first group, a
              2017 NCES study found that one-third of all bachelor's students
              change their major at least once and 1 in 10 students have changed
              their major more than once.
              <span className={s.cite}>4</span> With Shadower, students can
              efficiently narrow down the correct major for themselves before
              investing too much time and money pursing the wrong education or
              degree.
              <br />
              <br />
              Looking at the second group, a recent survey by Hanover Research
              asked over 5,000 postsecondary students what factors would have
              made them feel more prepared for their careers and as the data
              below show, the majority felt that they needed more internships
              and professional experience.
              <span className={s.cite}>5</span> Note also that better access to
              tools and networking ranked fairly high.
            </p>

            <img
              alt="Data on education"
              className={s.chart}
              src="/assets/images/about/demographics/charts/chart1.jpg"
            />

            <p>
              Overall, this result makes sense. When surveyed, employers
              overwhelmingly respond that they prefer for candidates have work
              experience. Consequently, it is vital for college students to
              specialize their knowledge through internships, but finding good
              internships can be challenging, which is where Shadower can help
              the third group of college students, those without internship
              options.
            </p>

            <p>
              According to the Chronicle of Higher Education, "In many colleges,
              the landscape of internships is best characterized as ambiguous,
              unregulated, potentially exploitative, and—for many
              students—inaccessible."
              <span className={s.cite}>6</span> The problem boils down to the
              fact that there simply aren't enough substantive internships
              available, especially for "disciplines that lack direct and
              obvious connections to employers." Data from the New York Times
              show the top 20 fields which posted the largest number of
              internships in the U.S. between September 2015 to October 2016.
              <span className={s.cite}>7</span>
            </p>

            <img
              alt="Data on education"
              className={s.chart}
              src="/assets/images/about/demographics/charts/chart2.jpg"
            />

            <p>
              In 2016, the United Stated had 19.84 million college students, but
              as the bar graph above reveals, the number of internship postings
              ranged somewhere in the hundreds of thousands. Of course, this
              does not account for internships informally acquired, so the real
              number is likely higher, but the point stands nonetheless. As the
              Chronicle explains, "For cash-strapped colleges, many of which may
              not have adequately resourced career centers, it is fantasy to to
              be able to design a mandatory internship program for all
              students." Students of these less-equipped colleges must cold-call
              various professors and companies on their own if they hope to get
              experience. If students don't know exactly what's available or
              fail to meet the required academic prerequisites, these challenges
              can, at times, feel insurmountable.
            </p>

            <p>
              It's worth noting that in the New York Times data plot,
              business-related activities account for four of the top seven
              spots; underrepresented are internships in creative and scientific
              fields, two areas where acquiring internships is most critical. By
              analyzing internship postings in relation to entry-level job
              openings, a Burning Glass report found that internships are most
              important in the competitive areas of art, video and graphic
              design, engineering, communications, marketing and social media.
              Shadower provides the perfect outlet for colleges students to get
              a foot in the door when it comes to those highly-competitive
              fields.
            </p>

            <p>
              As further evidence of the lack of hands-on education in America,
              consider the following data from the National Center for Education
              Statistics (NCES)
              <span className={s.cite}>8</span>, which show the number of
              schools offering subbaccalaureate occupational education in the
              United States in 2013, by state.
            </p>

            <img
              alt="Data on education"
              className={s.chart}
              src="/assets/images/about/demographics/charts/chart3.jpg"
            />

            <p>
              Using Colorado as an example, according to the Colorado Department
              of Higher Education, Colorado has 432 institutions of higher
              learning,
              <span className={s.cite}>9</span> but the NCES data show that only
              104 schools offer occupational education. Looking at the country
              as a whole, America has 7,151 postsecondary Title IV Institutions
              <span className={s.cite}>10</span> (and many, many more non-Title
              IV higher educational institutions) but only 5,590 offer
              occupational education.
              <span className={s.cite}>11</span> Shadower can partially fill
              this gap and the internship gap by providing a simple platform for
              students to find subbaccalaureate training. Shadower will allow
              many more students, especially those at smaller institutions, the
              chance to operate the tools of the industry and make face-to-face
              connections with possible future employers without requiring a
              formal internship.
            </p>
            <References
              referenceList={
                <div>
                  <ol>
                    <li>
                      <a
                        href="http://youthtruthsurvey.org/wp-content/uploads/2016/01/YouthTruth-Learning-From-Student-Voice-College-and-Career-Readiness-2016.pdf"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        YouthTruth Student Survey (2016)
                      </a>
                      ,&nbsp;
                      <i>
                        Most High Schoolers Feel Unprepared for College and
                        Careers.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.fastweb.com/career-planning/articles/how-to-arrange-and-conduct-a-job-shadow"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        FastWeb (2018)
                      </a>
                      ,&nbsp;
                      <i>How to Manage and Conduct a Job Shadow.</i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/524033/parents-children-tutoring-pay/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        HSBC (2018)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of parents who have paid or would pay for tutoring
                        for their child in selected countries in 2015.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://nces.ed.gov/pubs2018/2018434.pdf"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2017)
                      </a>
                      ,&nbsp;
                      <i>
                        College students tend to change majors when they find
                        the one they really love.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/731339/factors-that-would-have-helped-students-to-feel-more-prepared-for-their-careers-us/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Hanover Research, McGraw-Hill (2017)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of factors that would have made students feel more
                        prepared for their careers in the United States in 2017.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.chronicle.com/article/What-s-Wrong-With-Required/242727"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        The Chronicle of Higher Education (2018)
                      </a>
                      ,&nbsp;
                      <i>What's Wrong with Required Internships?</i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/673316/top-fields-for-internship-positions/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        New York Times, Burning Glass (2016)
                      </a>
                      ,&nbsp;
                      <i>
                        Occupational fields with the largest number of
                        internship postings in the United States from September
                        2015 to October 2016.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.burning-glass.com/research-project/internships-2015/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Burning Glass (2015)
                      </a>
                      ,&nbsp;
                      <i>
                        No Experience Necessary? The State of American
                        Internships 2015.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/782547/number-of-schools-offering-occupational-education-us-by-state/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2013)
                      </a>
                      ,&nbsp;
                      <i>
                        Number of postsecondary schools offering occupation
                        education in the U.S. in 2013, by state.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://highered.colorado.gov/Data/InstSelect.aspx"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        CHDE (2017)
                      </a>
                      ,&nbsp;
                      <i>Search Colleges and Universities.</i>
                    </li>

                    <li>
                      <a
                        href="https://nces.ed.gov/programs/digest/d17/tables/dt17_105.50.asp?current=yes"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2016)
                      </a>
                      ,&nbsp;
                      <i>
                        Number of educational institutions, by level and control
                        of institution: Selected years, 1980-81 through 2015-16.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/782528/number-of-schools-offering-occupational-education-us-by-school-type/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Number of postsecondary schools offering occupational
                        education in the U.S. from 2000 to 2014, by school type.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/334116/reasons-for-us-online-non-degree-classes-by-age/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        U.S. online learner reasons for taking online non-degree
                        classes as of January 2014, by age.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/334033/us-online-classes-tutorial-usage-income-levels/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of U.S. online population who have taken online
                        classes or tutorials as of January 2014, by income
                        levels.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/334040/us-online-classes-tutorial-usage-education-levels/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of U.S. online population who have taken online
                        classes or tutorials as of January 2014, by education
                        levels.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/184236/us-online-classes-tutrial-usage-age/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of U.S. online population who have taken online
                        classes or tutorials as of January 2014, by age.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/862627/us-employment-market-sources-of-new-opportunities-for-jobseekers/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Jobvite (2018)
                      </a>
                      ,&nbsp;
                      <i>
                        Main sources to learn of new opportunities for U.S. job
                        seekers in 2018.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.payscale.com/research/US/Job=Small_Business_Owner/Salary"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        REF (2017)
                      </a>
                      ,&nbsp;
                      <i>Small Business Owner Salary.</i>
                    </li>
                  </ol>
                </div>
              }
              referenceTitle="References"
            />
          </Panel.Body>
        </Panel>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(CollegeStudentsSection);
